import type { Law } from '~/utils/solr/law'

export function useLawIdParams(law: Law | string | string[]) {
  const route = useRoute()

  const query = computed(() => route.query)

  const lovId = computed(
    () => Array.isArray(law)
      ? law
      : typeof law === 'string'
        ? law.split('/').filter(Boolean)
        : [law.id],
  )

  return { lovId, query }
}
